import { TimeOfDay } from "./units/time-of-day";

export const NaiveTime = TimeOfDay;
export type NaiveTime = TimeOfDay;
